import api from './api';

export interface Notification {
  id: string;
  userId: string;
  tenantId: string;
  title: string;
  message: string;
  type: string;
  read: boolean;
  createdAt: string;
}

export interface NotificationListResponse {
  success: boolean;
  data: Notification[];
  count: number;
  total: number;
  unread: number;
  pagination?: {
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const notificationApi = {
  /**
   * Lista notificações do usuário autenticado
   */
  getNotifications: async (params?: {
    read?: boolean;
    limit?: number;
    page?: number;
    type?: string;
  }): Promise<NotificationListResponse> => {
    const response = await api.get('/notifications', { params });
    return response.data;
  },

  /**
   * Marca uma notificação como lida
   */
  markAsRead: async (notificationId: string): Promise<void> => {
    await api.put(`/notifications/${notificationId}/read`);
  },

  /**
   * Marca todas as notificações como lidas
   */
  markAllAsRead: async (): Promise<{ success: boolean; count: number }> => {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },

  /**
   * Remove uma notificação
   */
  deleteNotification: async (notificationId: string): Promise<void> => {
    await api.delete(`/notifications/${notificationId}`);
  },
};

